"use strict";
// Extension points declared by core and by the web-app surface.
//
// Core is modelled as a plugin like any other, so "check the site before
// publish" and "add a payment provider" go through the same declare/provide
// mechanism. Only points something provides or consumes are declared here;
// add one when its host side exists (DeployCheckRegistry, DeployTransformRegistry).
// Core knows nothing about Workers or D1; the web-app surface is the target
// plugins ship app code into (targets['web-app']). A future mobile or
// creatives surface is declared the same way, without touching core.
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUILTIN_PLUGINS = exports.WEB_APP_SURFACE = exports.CORE_PLUGIN = void 0;
exports.CORE_PLUGIN = {
    id: 'core',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Dunea core',
    description: 'Projects, chat and agent loop, sandbox, deploy, billing. Declares the core extension points.',
    declares: {
        'core.deploy.check': {
            major: 1,
            cardinality: 'many',
            description: 'A check run before publish. Errors stop the publish; warnings are shown to the owner.',
        },
        'core.deploy.transform': {
            major: 1,
            cardinality: 'many',
            description: 'Edits the published site at deploy (head tags, verification meta, chat widgets). Production only, never preview.',
        },
        'core.studio.module': {
            major: 1,
            cardinality: 'many',
            description: 'A backend module compiled into studio. First-party only.',
        },
    },
    // Core's own pre-publish check: the app's enabled plugins resolve (nothing missing).
    provides: {
        'core.deploy.check': { major: 1 },
    },
    emits: {
        'core.app.published': { major: 1, description: 'A production deploy of the app finished (siteUrl in payload).' },
    },
};
exports.WEB_APP_SURFACE = {
    id: 'web-app',
    version: '1.0.0',
    kind: 'surface',
    trust: 'first-party',
    title: 'Web app',
    description: 'Vite + React frontend, Hono API on Cloudflare Workers, per-app D1 database.',
    icon: 'i-ph:browser',
};
/** Built-in plugins that are always enabled. */
exports.BUILTIN_PLUGINS = [exports.CORE_PLUGIN, exports.WEB_APP_SURFACE];
